import React from 'react';
import { PaginationInfoType } from '@shared/api/graphql/generated';
import InView from 'react-intersection-observer';
import Popper from '@zvuk-b2b/react-uikit/ui/Popper';
import ChooseItemListItem, { SelectorType } from './ChooseItemListItem';
import PointItemContent from '../../PointItemContent';
import { PointsListCheckboxGroupPointType } from '../../types';
import styles from '../index.module.scss';
import TEXTS from '../texts';

export type ChooseItemListType = {
  onChange: (value: any, currentItem: PointsListCheckboxGroupPointType) => void;
  itemList: Array<PointsListCheckboxGroupPointType>;
  selectedItems: Array<PointsListCheckboxGroupPointType>;
  selectorType: SelectorType;
  isLoading: boolean;
  isReloading?: boolean;
  paginationSettings?: PaginationInfoType;
  loadMore?: () => void;
};

const ChooseItemList = ({
  itemList,
  onChange,
  selectorType,
  isLoading,
  selectedItems,
  loadMore,
  paginationSettings,
  isReloading,
}: ChooseItemListType) => {
  const showSkeleton = isLoading || (isReloading && !itemList.length);
  const skeletonItems = showSkeleton ? new Array(20).fill(null).map((_, id) => ({ id: String(id) })) : undefined;

  const selectedItemsSet = new Set(selectedItems.map((it) => String(it.id)));

  return (
    <>
      {itemList.map((currentItem) => (
        <ChooseItemListItem
          isChecked={selectedItemsSet.has(String(currentItem.id))}
          currentItem={currentItem}
          onChange={(value: boolean) => onChange(value, currentItem)}
          selectorType={selectorType}
          isLoading={false}
          isDisabled={isReloading || isLoading || currentItem.isDisabled}>
          <div className={styles.content}>
            <PointItemContent
              isLoading={false}
              currentItem={currentItem}
              disabled={currentItem.isDisabled}
            />
            {currentItem.isDisabled && (
              // TODO Fix Icon in figma
              <Popper
                triggerNode={
                  <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_43467_24152)">
                      <path
                        d="M10.0003 6.66675V10.0001M10.0003 13.3334H10.0087M18.3337 10.0001C18.3337 14.6025 14.6027 18.3334 10.0003 18.3334C5.39795 18.3334 1.66699 14.6025 1.66699 10.0001C1.66699 5.39771 5.39795 1.66675 10.0003 1.66675C14.6027 1.66675 18.3337 5.39771 18.3337 10.0001Z"
                        stroke="#FFBF00"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_43467_24152">
                        <rect
                          width="20"
                          height="20"
                          fill="white"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                }>
                {TEXTS.IN_OTHER_GROUP}
              </Popper>
            )}
          </div>
        </ChooseItemListItem>
      ))}

      {paginationSettings?.hasNextPage && (
        <InView
          onChange={(inView) => inView && loadMore?.()}
          key="infinite_medialist_hidden_loading_zone"
        />
      )}

      {showSkeleton &&
        skeletonItems?.map((currentItem: PointsListCheckboxGroupPointType) => (
          <ChooseItemListItem
            isChecked={selectedItems.map((selectedItem) => selectedItem.id).includes(currentItem.id)}
            currentItem={currentItem}
            onChange={(value: boolean) => onChange(value, currentItem)}
            selectorType={selectorType}
            isLoading
            isDisabled>
            <PointItemContent
              isLoading
              currentItem={currentItem}
            />
          </ChooseItemListItem>
        ))}
    </>
  );
};

export default ChooseItemList;
